import { z } from 'zod';
import { IsoDate, MoneyAmount, UuidString } from '../primitives.js';
import { BudgetAccountCode, BudgetLineDirection } from './budget.js';

/**
 * S16-BE.1 — Budget variance report (computed DTO, fact vs plan).
 * Thresholds: warning ±10%, critical ±25% (via tolerance-thresholds.v1.json).
 */

export const VarianceFlag = z.enum(['ok', 'warning', 'critical']);
export type VarianceFlag = z.infer<typeof VarianceFlag>;

export const BudgetVarianceLine = z.object({
  account_code: BudgetAccountCode,
  account_name_ru: z.string(),
  direction: BudgetLineDirection,
  plan_amount: MoneyAmount,
  actual_amount: MoneyAmount,
  variance_amount: MoneyAmount,
  variance_pct: MoneyAmount,
  flag: VarianceFlag,
});
export type BudgetVarianceLine = z.infer<typeof BudgetVarianceLine>;

export const BudgetVarianceTotals = z.object({
  revenue_plan: MoneyAmount,
  revenue_actual: MoneyAmount,
  revenue_variance: MoneyAmount,
  cost_plan: MoneyAmount,
  cost_actual: MoneyAmount,
  cost_variance: MoneyAmount,
  profit_plan: MoneyAmount,
  profit_actual: MoneyAmount,
  profit_variance: MoneyAmount,
});
export type BudgetVarianceTotals = z.infer<typeof BudgetVarianceTotals>;

export const BudgetVariancePeriod = z.object({
  date_from: IsoDate,
  date_to: IsoDate,
});
export type BudgetVariancePeriod = z.infer<typeof BudgetVariancePeriod>;

export const BudgetVarianceReport = z.object({
  budget_id: UuidString,
  period: BudgetVariancePeriod,
  lines: z.array(BudgetVarianceLine),
  totals: BudgetVarianceTotals,
  schema_version: z.string(),
});
export type BudgetVarianceReport = z.infer<typeof BudgetVarianceReport>;
